import { BestuurlijkeGebiedenWebService } from "../webservices/bestuurlijke-gebieden.web.service";
import { retryWithAuth } from "./utils/retryWithAuth";

export class BestuurlijkeGebiedenService {
  
  // Private static instance of the class (singleton)
  private static instance: BestuurlijkeGebiedenService;

  // Private constructor to prevent direct instantiation
  private constructor() {}

  // Method to return the singleton instance
  public static getInstance(): BestuurlijkeGebiedenService {
    if (!BestuurlijkeGebiedenService.instance) {
      BestuurlijkeGebiedenService.instance = new BestuurlijkeGebiedenService();
    }
    return BestuurlijkeGebiedenService.instance;
  }

  public async getRoutes(): Promise<any> {
    const bestuurlijkeGebiedenWebService = new BestuurlijkeGebiedenWebService();

    return retryWithAuth(() => bestuurlijkeGebiedenWebService.getBestuurlijkeGebiedenRoutes(), 2);
  }

  public async getBestuurlijkeGebiedenByRoute(route: string): Promise<any> {
    const bestuurlijkeGebiedenWebService = new BestuurlijkeGebiedenWebService();

    return retryWithAuth(() => bestuurlijkeGebiedenWebService.getBestuurlijkeGebiedenByRoute(route), 2);
  }

  public async autocompleteByTypeAndName(type: string, name: string): Promise<any> {
    const bestuurlijkeGebiedenWebService = new BestuurlijkeGebiedenWebService();

    return retryWithAuth(() => bestuurlijkeGebiedenWebService.autocompleteByTypeAndName(type, name), 2);
  }
};

// Export an instance of the OrganisatieService class
export const bestuurlijkeGebiedenService = BestuurlijkeGebiedenService.getInstance();